import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Navbar from "../../components/marketing/Navbar";
import Footer from "../../components/marketing/Footer";
import { COMPETITORS } from "../../mock";

export default function CompareHub() {
  useEffect(() => {
    document.title = "Compare Full Bench to alternatives — side-by-side reviews (2026)";
    setMeta("description", "Honest, up-to-date comparisons of Full Bench vs Harvest, Toggl Track, Clockify, Hubstaff, Timely, FreshBooks and more. See features, pricing, and which is better for your consulting team.");
  }, []);

  const items = COMPETITORS;

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-8">
        <div className="text-sm text-coral font-semibold uppercase tracking-wide">Comparisons</div>
        <h1 className="font-display text-5xl md:text-6xl mt-3 max-w-3xl">Full Bench vs. the alternatives.</h1>
        <p className="mt-4 text-[#3f4a44] max-w-2xl">Fair, in-depth reviews of Full Bench against the tools most consulting teams shortlist. Pricing, features, ease of use, and an honest verdict on every page.</p>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-20 grid md:grid-cols-2 gap-4">
        {items.map((c) => (
          <Link key={c.slug} to={`/compare/${c.slug}`}
            className="group bg-white rounded-xl border border-cream p-6 hover:-translate-y-0.5 hover:shadow-md transition-all flex items-start gap-4">
            <div className="h-12 w-12 rounded-lg text-white font-bold flex items-center justify-center shrink-0" style={{ background: c.color }}>
              {c.logoLetter}
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <div className="font-semibold">Full Bench vs {c.name}</div>
                <ArrowRight size={16} className="text-coral group-hover:translate-x-0.5 transition-transform" />
              </div>
              <div className="text-sm text-[#3f4a44] mt-1">{c.tagline}</div>
              <div className="text-xs text-[#6a736f] mt-3 line-clamp-2">{c.intro}</div>
            </div>
          </Link>
        ))}
      </section>

      <Footer />
    </div>
  );
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
